import API from '@/api/api'

export default {
  async login (username, password, config = {}) {
    const defaultConfig = { ...config }
    return await API.restRequest(API.endpoint.auth.login, {
      email   : username,
      password: password
    }, defaultConfig)
  },

  async logout () {
    return await API.restRequest(API.endpoint.auth.logout)
  }
}
